export default __webpack_public_path__ + "static/media/330D.3cbe782f.jpg";